<template>
  <Toaster position="bottom-right" rich-colors />
  <router-view />
</template>

<script setup>
import { Toaster } from "@/components/ui/sonner"
</script>

<style lang="sass"></style>
